import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import check from "../../images/build-Check.svg";
import { Formik, Form } from "formik";
import { GET_CATEGORIES } from "../../query/GetCategories";
import { hasuraClient } from "../../apolloClient";

const BusinessCategories = (props) => {
  const { data: categories } = useQuery(GET_CATEGORIES, {
    client: hasuraClient,
  });

  const [dynamicData, setDynamicData] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
  ]);
  const [key, setKey] = useState(0);

  const handleSubmit = () => {
    var categoryString = "";
    categories.categories.map((item, index) => {
      if (dynamicData[index]) {
        categoryString += item.id + ",";
      }
    });
    categoryString = categoryString.substring(0, categoryString.length - 1);
    const value = { categories: "" };
    value.categories = categoryString;
    props.next(value);
  };

  useEffect(() => {
    if (categories) {
      const data = [];
      categories?.categories.map((item, index) => (data[index] = false));
      if (props?.step2Data?.length > 0) {
        setDynamicData(props?.step2Data);
      } else {
        setDynamicData(data);
      }
    }
  }, [categories]);

  useEffect(() => {
    if (props?.step2Data) {
      setDynamicData(props?.step2Data);
    }
  }, [props?.step2Data]);

  const setActiveCategory = (index) => {
    const data = dynamicData;
    data[index] = data[index] ? false : true;
    setKey(key + 1);
    props?.setDynamicData(data);
    setDynamicData(data);
  };

  return (
    <Formik initialValues={props.data} onSubmit={handleSubmit}>
      {() => (
        <Form>
          <div className="businessprofile-cover">
            <h1>Please select your category</h1>
            <div className="businees-categories">
              <ul className="businees-categories-list">
                {categories
                  ? categories.categories.map((item, index) => {
                      return (
                        <li
                          onClick={() => {
                            setActiveCategory(index);
                          }}
                        >
                          <div className="categories-row">
                            <div className="categories-img">
                              <img src={item.image_url} alt="event" />
                              {dynamicData && dynamicData[index] ? (
                                <div className="build-active">
                                  <span>
                                    <img src={check} alt="check-mark" />
                                  </span>
                                </div>
                              ) : null}
                            </div>
                            <p>{item.name}</p>
                          </div>
                        </li>
                      );
                    })
                  : null}
              </ul>
              <div className="form-submit">
                <button className="back-btn" onClick={props.previous}>
                  Back
                </button>
                <button type="submit" className="submit-btn">
                  Next
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default BusinessCategories;
